module.exports = __webpack_public_path__ + "static/img/图片17.960fdfc9.png";